import React from "react"
import arrowLeft from "../icons/arrow_left"
import arrowRight from "../icons/arrow_right"
import close from "../icons/close"

const icons = {
  arrowLeft, arrowRight, close 
}

const Icon = ({
  fill = "#fff", type, ...props 
}) => {
  const icon = icons[type]

  return <span dangerouslySetInnerHTML={{
    __html: icon(fill) 
  }} {...props} />
}

export default Icon
